// @flow
// $FlowFixMe  loaded by worker-loader
import Worker from "./pgp.worker.js";
// $FlowFixMe  loaded by worker-loader
export const pgpThread = new Worker();
